import type {ComponentWithAs} from '@chakra-ui/system';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';
import type {ComponentProps} from 'react';
import {LineChart, ResponsiveContainer} from 'recharts';

import {useStatStyle} from '../../theme-config';

type Props = {} & ComponentProps<typeof LineChart>;

const StatChart: ComponentWithAs<typeof LineChart, Props> = ({...props}) => {
  const style = useStatStyle(`chart`, props);
  const {
    minWidth,
    minHeight,
    maxHeight,
    height = `100%`,
    width = `100%`,
    maxWidth = `100`,
  }: Partial<CSSStyleDeclaration> = props.style ?? {};
  return (
    // ResponsiveContainer doesn't accept maxWidth, so we need to wrap it in a div
    <ChakraDiv width={`full`} margin={`12`} maxW={maxWidth} {...props.style}>
      <ResponsiveContainer
        width={width}
        height={height}
        minWidth={minWidth}
        minHeight={minHeight}
        maxHeight={Number.isNaN(Number(maxHeight)) ? undefined : Number(maxHeight)}>
        <LineChart sx={style} {...(props as any)}>
          {props.children}
        </LineChart>
      </ResponsiveContainer>
    </ChakraDiv>
  );
};

export default StatChart;
